import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { ProductsSubscriptionAdminResponse, ProductsSubscriptionsAdminParams } from './types';

/** The list envelope plus the COUNT the server runs over the same WHERE. */
export type ProductsSubscriptionsAdminResponse = PaginatedListResponse<ProductsSubscriptionAdminResponse> & {
  total?: number | null;
};

export async function listAdminProductsSubscriptions(params: ProductsSubscriptionsAdminParams = {}) {
  const url = '/web/studio/admin/products-subscriptions';

  const queryParams: Record<string, string | number> = {};

  if (params.search) queryParams.search = params.search;
  if (params.store) queryParams.store = params.store;
  if (params.status) queryParams.status = params.status;
  if (params.limit !== undefined) queryParams.limit = params.limit;
  if (params.offset !== undefined) queryParams.offset = params.offset;

  const response = await api.executeGetRequest<ProductsSubscriptionsAdminResponse>(url, queryParams);

  return response;
}
